import React, { useState, useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import _, { isEmpty, get, cloneDeep } from "lodash";
import { formFields } from "./constant"; // Import your formFields constant
import Input from "../../../../components/FormElements/Input";
import ToastModal from "../../../../components/ToastModal";
import SelectNew from "../../../../components/FormElements/SelectNew";
import { Link, withRouter } from 'react-router-dom';
import routes from '../../../../routes';

import {
    handleFieldError,
    handleError,
} from "../../../../utils/form-validation";

import {
    getDataConfigValuesListAction,
    getListByIdVariableAction,
    postDataConfigAction
} from "../../../../actions";

const AddDataConfig = (props) => {
    const [touched, setTouched] = useState({});
    const [errors, setErrors] = useState({});
    const [submited, setSubmited] = useState(false);
    const [form, setForm] = useState({});
    const [mappingVariables, setMappingVariables] = useState([]);
    const [mappingValues, setMappingValues] = useState([]);
    const [platformData, setPlatformData] = useState([]);
    const [attributeValues, setAttributeValues] = useState([
        {
            primaryValue: "",
            mappingValue: "",
            errors: {},
            touched: {}
        },
    ]);

    const [toastModal, setToastModal] = useState({
        enableToast: false,
        toastStatus: "",
        toastMsg: ""
    });
    const tenantId = useSelector((state) => get(state, "app.preSignInState.tenantId", ""));
    const userId = useSelector((state) => get(state, "app.preSignInData.userId", ""));
    const authToken = useSelector((state) => get(state, "app.signInData.authToken", ""));
    const dispatch = useDispatch();

    const handleAddRow = () => {
        setAttributeValues((prevAttrValues) => [
            ...prevAttrValues,
            {
                primaryValue: "",
                mappingValue: "",
                errors: {},
                touched: {}
            },
        ]);
    };

    const handleDeleteRow = (index) => {
        setAttributeValues((prevAttrValues) => {
            const updatedAttrValues = [...prevAttrValues];
            updatedAttrValues.splice(index, 1);
            return updatedAttrValues;
        });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        const newForm = { ...form };
        newForm[e.target.name] = value;
        setForm(newForm);
    };

    const handleAttributeChange = (e, index) => {
        const newAttributeValues = [...attributeValues];
        newAttributeValues[index] = {
            ...newAttributeValues[index],
            [e.target.name]: e.target.value
        };
        setAttributeValues(newAttributeValues);
    }

    const handleTouch = (e) => {
        const newTouched = { ...touched };
        const newErrors = { ...errors };
        const { error } = handleFieldError(e.target.value, formFields[e.target.name]);
        newErrors[e.target.name] = error;
        newTouched[e.target.name] = true;
        setTouched(newTouched);
        setErrors(newErrors);
    };

    const handleAttributeTouch = (e, index) => {
        const newAttributeValues = [...attributeValues];
        const { error } = handleFieldError(e.target.value, formFields[e.target.name]);
        newAttributeValues[index] = {
            ...newAttributeValues[index],
            [e.target.name]: e.target.value,
            errors: {
                ...newAttributeValues[index].errors,
                [e.target.name]: error
            },
            touched: {
                ...newAttributeValues[index].touched,
                [e.target.name]: true
            }
        };
        setAttributeValues(newAttributeValues);
    };

    const resetMappingValues = () => {
        const modifiedAttributeValues = attributeValues.map(attribute => {
            return {
                ...attribute,
                mappingValue: ''
            }
        });
        setAttributeValues(modifiedAttributeValues);
    };

    const getMappingValuesOptions = (index) => {
        const selectedMappingValues = attributeValues.filter((attribute, aIndex) => aIndex !== index);
        const selectedMappingValueIds = selectedMappingValues.map(item => parseInt(item.mappingValue));
        if (selectedMappingValueIds && selectedMappingValueIds.length > 0) {
            let filteredMappingValues = mappingValues.filter(mappingValue => !selectedMappingValueIds.includes(mappingValue.id));
            return filteredMappingValues;
        } else {
            return mappingValues;
        }
    };

    const initializeList = async () => {
        await getPlatformList();
        await getMappingVariableList();
    };

    const resetForm = () => {
        setErrors({});
        setTouched({});
        setSubmited(false);
        setAttributeValues([
            {
                primaryValue: "",
                mappingValue: "",
                errors: {},
                touched: {}
            },
        ]);
        setForm({
            attributes: '',
            platform: '',
            mappingVariable: ''
        });
    };

    const submitForm = async (id) => {
        let addParams = { addup: 'auto' };
        // if (id) {
        //     addParams = { action: 'update' };
        // }

        let payload = {
            name: form.attributes,
            platformId: parseInt(form.platform)
        };
        if (form[formFields.mappingVariable.key]) {
            payload.attributeMapping = parseInt(form[formFields.mappingVariable.key]);
            payload.list = attributeValues.map(attribute => {
                return (
                    {
                        name: attribute.primaryValue,
                        attributeMapping: parseInt(attribute.mappingValue)
                    }
                )
            });
        } else {
            payload.list = attributeValues.map(attribute => {
                return (
                    {
                        name: attribute.primaryValue,
                    }
                )
            });
        }

        await dispatch(postDataConfigAction({ tenantId, authToken, userId, params: addParams, payload }))
            .then((data) => {
                const {
                    responseCode: { status = "", msg },
                    response,
                } = data;
                if (status === "Success") {
                    // console.log(response);
                    // console.log(status);
                    toast(status, msg);
                    resetForm();
                } else {
                    console.log("Unable to add variable!");
                }
            })
            .catch((error) => {
                console.error(error);
            });
        // this.formInitialize();
    }

    const validate = () => {
        let { errors, valid } = handleError(form, { attributes: formFields.attributes, platform: formFields.platform });
        let counter = 0;
        const newAttributeValues = attributeValues.map(attribute => {
            for (const property in attribute) {
                if (property !== 'errors' && property !== 'touched') {
                    let { error, isValid } = handleFieldError(attribute[property], formFields[property]);
                    attribute['errors'][property] = error;
                    if (!isValid) {
                        counter++;
                    }
                }
            }
            return attribute;
        });
        setErrors(errors);
        setAttributeValues(newAttributeValues);
        setSubmited(true);
        return counter == 0 && valid;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        let valid = validate();
        if (valid) {
            let confirmationMessage = "Kindly let us know if you'd like to save your changes.";
            toast('confirmation', confirmationMessage);
        }
    };

    const editId = async () => {
        const { match: { params: { id } } } = props;
        if (id) {
            await dispatch(getListByIdVariableAction({ tenantId, authToken, userId, platformId: id }))
                .then((data) => {
                    const {
                        responseCode: { status = "" },
                        response,
                    } = data;
                    if (status === "Success" && response && response.length > 0) {
                        // console.log(response, 'RESPONSE');
                        let variableData = response ? response[0] : null;
                        let updatedAttributeValues = [];
                        let updatedForm = {
                            ...form,
                            [formFields.attributes.key]: variableData.name,
                            [formFields.platform.key]: variableData.platformId
                        };
                        if (variableData.attributeMapping) {
                            updatedForm[formFields.mappingVariable.key] = variableData.attributeMapping;
                            updatedAttributeValues = variableData.list.map(item => {
                                return {
                                    id: item.id,
                                    primaryValue: item.name,
                                    isActive: item.isActive,
                                    mappingValue: item.attributeMapping,
                                    errors: {},
                                    touched: {}
                                }
                            });
                        } else {
                            updatedAttributeValues = variableData.list.map(item => {
                                return {
                                    id: item.id,
                                    primaryValue: item.name,
                                    isActive: item.isActive,
                                    mappingValue: "",
                                    errors: {},
                                    touched: {}
                                }
                            });
                        }
                        setForm(updatedForm);
                        setAttributeValues(updatedAttributeValues);
                    } else {
                        console.log("Variable not found");
                    }
                })
                .catch((error) => {
                    console.error(error);
                });

            // const {
            //     responseCode: { status = "" },
            //     responseList,
            // } = await getListByIdVariableAction({
            //     tenantId,
            //     authToken,
            //     userId,
            //     id,
            // });

            // if (status === "Success" && responseList.length > 0) {

            // }
        }
    };

    const toast = (status, msg, type) => {
        setToastModal({
            enableToast: true,
            toastStatus: status,
            toastMsg: msg
        });
        return;
    }

    const handleToastStatus = async (status) => {
        setToastModal({
            ...toastModal,
            enableToast: status
        });
    };

    const confirmationCallbackModel = (id) => {
        setToastModal({
            ...toastModal,
            enableToast: false
        });
        if (!id) {
            submitForm(id);
        }
        // if (method === "recActiveStatus") {
        //   handleStatusUpdate();
        // }
    };

    const getPlatformList = async () => {
        let params = { list: 'all', type: 'platform' };
        await dispatch(getDataConfigValuesListAction({ tenantId, authToken, userId, params }))
            .then((data) => {
                const {
                    responseCode: { status = "" },
                    response,
                } = data;
                if (status === "Success" && response && response.length > 0) {
                    setPlatformData(response);
                } else {
                    console.log("Platform list not found");
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }

    const getMappingVariableList = async () => {
        let params = { list: 'all', type: 'parent' };
        await dispatch(getDataConfigValuesListAction({ tenantId, authToken, userId, params }))
            .then((data) => {
                const {
                    responseCode: { status = "" },
                    response,
                } = data;
                if (status === "Success" && response && response.length > 0) {
                    const processedMappingVariableList = response.map(item => {
                        return {
                            ...item,
                            name: `${item.name} (${item.platformName})`
                        }
                    })
                    setMappingVariables(processedMappingVariableList);
                } else {
                    console.log("Mapping variable list not found");
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }

    const getMappingValuesList = async (id) => {
        let params = { list: 'all', type: 'child', attribute: id };
        await dispatch(getDataConfigValuesListAction({ tenantId, authToken, userId, params }))
            .then((data) => {
                const {
                    responseCode: { status = "" },
                    response,
                } = data;
                if (status === "Success" && response && response.length > 0) {
                    setMappingValues(response);
                } else {
                    console.log("Mapping variable list not found");
                }
            }).catch((error) => {
                console.error(error);
            });
    }

    useEffect(() => {
        const { match: { params: { id } }, } = props;
        if (id) {
            editId();
        }
        initializeList();
        return () => {
            formFields[formFields.mappingValue.key][`required`] = false;
        }
    }, []);

    if (form[formFields.mappingVariable.key]) {
        formFields[formFields.mappingValue.key][`required`] = true;
    }

    return (
        <>
            {
                toastModal.enableToast && <ToastModal
                    enableToast={toastModal.enableToast}
                    status={toastModal.toastStatus}
                    msg={toastModal.toastMsg}
                    path={routes.containers.dataConfig + '/' + routes.dataConfig.variables.name}
                    idProps={props}
                    handleConfirmation={confirmationCallbackModel}
                    handleToastStatus={handleToastStatus}
                    confirmationMsg={toastModal.toastMsg}
                    poc={false}
                    outSideClickEnable={false}
                />
            }
            <div className="main-panel ion">
                <div className="content-wrapper">
                    <div className="row justify-content-center mt-3 px-4">
                        <div className="col-md-4 ">
                            <Input
                                onChange={handleChange}
                                onBlur={handleTouch}
                                value={form[formFields.attributes.key]}
                                setting={formFields[formFields.attributes.key]}
                                error={errors[formFields.attributes.key]}
                                submited={submited}
                                touched={touched[formFields.attributes.key]}
                            />
                        </div>
                        <div className="col-md-4 ">
                            <SelectNew
                                onChange={handleChange}
                                onBlur={handleTouch}
                                value={form[formFields.platform.key]}
                                setting={formFields[formFields.platform.key]}
                                error={errors[formFields.platform.key]}
                                submited={submited}
                                touched={touched[formFields.platform.key]}
                                options={platformData}
                            />
                        </div>

                        <div className="col-md-4 ">
                            <SelectNew
                                onChange={(e) => {
                                    handleChange(e);
                                    resetMappingValues();
                                    getMappingValuesList(e.target.value);
                                }}
                                onBlur={handleTouch}
                                value={form[formFields.mappingVariable.key]}
                                setting={formFields[formFields.mappingVariable.key]}
                                error={errors[formFields.mappingVariable.key]}
                                submited={submited}
                                touched={touched[formFields.mappingVariable.key]}
                                options={mappingVariables}
                            />
                        </div>
                    </div>

                    <div className="form-group row">
                        <div className="position-relative">
                            {attributeValues.map((attribute, index) => (
                                <div
                                    key={index}
                                    className="form-group row mt-4 ml-2 position-relative"
                                >
                                    <div className="col-md-4">
                                        <Input
                                            onChange={(e) => handleAttributeChange(e, index)}
                                            onBlur={(e) => handleAttributeTouch(e, index)}
                                            value={attribute[formFields.primaryValue.key]}
                                            setting={formFields[formFields.primaryValue.key]}
                                            error={attribute[`errors`][formFields.primaryValue.key]}
                                            submited={submited}
                                            touched={attribute[`touched`][formFields.primaryValue.key]}
                                        />
                                    </div>

                                    {/* <div className="col-md-3">
                                    <Input
                                        onChange={(e) => handleAttributeChange(e, index)}
                                        onBlur={(e) => handleAttributeTouch(e, index)}
                                        value={attribute[formFields.thirdPartyValue.key]}
                                        setting={formFields[formFields.thirdPartyValue.key]}
                                        error={attribute[`errors`][formFields.thirdPartyValue.key]}
                                        submited={submited}
                                        touched={attribute[`touched`][formFields.thirdPartyValue.key]}
                                    />
                                </div> */}

                                    {
                                        form[formFields.mappingVariable.key] &&
                                        <div className="col-md-4">
                                            <SelectNew
                                                onChange={(e) => handleAttributeChange(e, index)}
                                                onBlur={(e) => handleAttributeTouch(e, index)}
                                                value={attribute[formFields.mappingValue.key]}
                                                setting={formFields[formFields.mappingValue.key]}
                                                error={attribute[`errors`][formFields.mappingValue.key]}
                                                submited={submited}
                                                touched={attribute[`touched`][formFields.mappingValue.key]}
                                                options={getMappingValuesOptions(index)}
                                            />
                                        </div>
                                    }

                                    {index > 0 && (
                                        <div className="col-md-4">
                                            <button
                                                className="btn btn-danger delete-circular-btn"
                                                onClick={() => handleDeleteRow(index)}
                                                style={{ right: "50%" }}
                                            >
                                                <i className="mdi mdi-delete mr-0"></i>
                                            </button>
                                        </div>
                                    )}
                                </div>
                            ))}

                            <button
                                className="btn btn-primary circular-btn-daypart"
                                onClick={handleAddRow}
                                style={{ right: "8%" }}
                            >
                                +
                            </button>
                        </div>
                    </div>

                    <div className="form-group row">
                        <div className="col-sm-12">
                            <center>
                                <button type="submit" onClick={handleSubmit} className="btn btn-primary mx-4">Save</button>
                                {' '}
                                {' '}
                                <Link to={`/${routes.mainRoute}/${routes.containers.dataConfig}/${routes.dataConfig.variables.name}`}><button type="button" className="btn btn-secondary">Cancel</button></Link>
                            </center>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
};

export default withRouter(AddDataConfig);